export const APP     = window.APP || {};
export const SESSION = APP.session || {};
export const VERSION = APP.version || "V1_30";
export const URL_PHP = APP.URL_PHP || "https://divantys.com/";

// Aseguramos la existencia en el objeto global real de la ventana
window.APP = window.APP || {};
window.APP.userStatusData = window.APP.userStatusData || null;

/**
 * Guarda los datos en el objeto global real del navegador
 * @param {Object} data 
 */
export function setGlobalUserStatus(data) {
  window.APP.userStatusData = data;
}

/**
 * Obtiene los datos del objeto global real del navegador
 * @returns {Object|null}
 */
export function getGlobalUserStatus() {
  return window.APP ? window.APP.userStatusData : null;
}